import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function MobileCTA() {
  const { formatted_phone, phone_link } = useSiteConfig();
  
  return (
    <div className="mobile-sticky-cta md:hidden">
      <a href={phone_link} className="block w-full">
        <Button 
          data-testid="mobile-call-btn"
          className="w-full bg-[#b51a00] hover:bg-[#8a1300] text-white font-bold uppercase tracking-wider rounded-sm py-4 flex items-center justify-center gap-2"
        >
          <Phone className="w-5 h-5" />
          Call Now - {formatted_phone}
        </Button>
      </a>
    </div>
  );
}
